import {
    Tool01,
    ReverseLeft,
    SwitchHorizontal01,
} from '@untitled-ui/icons-react'

// Couleurs par équipe
// - Blue    → Service client
// - Pink    → Atelier
// - Orange  → Logistique
// - Gray    → Terminaux (aucune équipe)
// - Red     → Refusé

// Statuts des service cases
export const serviceCaseStatuses = {
    waiting_acceptation: {
        label: 'Demande reçue',
        classes: {
            dot: 'bg-blue-500',
            text: 'text-blue-500',
            bg: 'bg-blue-50',
            border: 'border-blue-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['service_client'],
    },
    customer_contacted: {
        label: 'Client contacté',
        classes: {
            dot: 'bg-blue-500',
            text: 'text-blue-500',
            bg: 'bg-blue-50',
            border: 'border-blue-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['service_client'],
    },
    in_store_dropoff: {
        label: 'Déposé en boutique',
        classes: {
            dot: 'bg-blue-500',
            text: 'text-blue-500',
            bg: 'bg-blue-50',
            border: 'border-blue-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['service_client'],
    },
    waiting_shipment: {
        label: "Livraison à l'atelier",
        classes: {
            dot: 'bg-orange-500',
            text: 'text-orange-500',
            bg: 'bg-orange-50',
            border: 'border-orange-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['logistique'],
    },
    received: {
        label: 'Reçu',
        classes: {
            dot: 'bg-pink-500',
            text: 'text-pink-500',
            bg: 'bg-pink-50',
            border: 'border-pink-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['atelier'],
    },
    watchmaker_diagnosis: {
        label: 'Diagnostic horloger',
        classes: {
            dot: 'bg-pink-500',
            text: 'text-pink-500',
            bg: 'bg-pink-50',
            border: 'border-pink-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['atelier'],
    },
    quote_to_prepare: {
        label: 'Devis à préparer',
        classes: {
            dot: 'bg-blue-500',
            text: 'text-blue-500',
            bg: 'bg-blue-50',
            border: 'border-blue-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['service_client'],
    },
    quote_sent: {
        label: 'Devis envoyé',
        classes: {
            dot: 'bg-blue-500',
            text: 'text-blue-500',
            bg: 'bg-blue-50',
            border: 'border-blue-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['service_client'],
    },
    quote_accepted: {
        label: 'Devis payé',
        classes: {
            dot: 'bg-pink-500',
            text: 'text-pink-500',
            bg: 'bg-pink-50',
            border: 'border-pink-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['atelier'],
    },
    quote_refused: {
        label: 'Devis refusé',
        classes: {
            dot: 'bg-pink-500',
            text: 'text-pink-500',
            bg: 'bg-pink-50',
            border: 'border-pink-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['atelier'],
    },
    repairing: {
        label: 'En réparation',
        classes: {
            dot: 'bg-pink-500',
            text: 'text-pink-500',
            bg: 'bg-pink-50',
            border: 'border-pink-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['atelier'],
    },
    quality_control: {
        label: 'En contrôle qualité',
        classes: {
            dot: 'bg-pink-500',
            text: 'text-pink-500',
            bg: 'bg-pink-50',
            border: 'border-pink-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['atelier'],
    },
    with_courier: {
        label: 'En livraison à la boutique',
        classes: {
            dot: 'bg-orange-500',
            text: 'text-orange-500',
            bg: 'bg-orange-50',
            border: 'border-orange-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['logistique'],
    },
    to_store: {
        label: 'Renvoi à la boutique',
        classes: {
            dot: 'bg-orange-500',
            text: 'text-orange-500',
            bg: 'bg-orange-50',
            border: 'border-orange-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['logistique'],
    },
    ready_in_store: {
        label: 'Prêt en boutique',
        classes: {
            dot: 'bg-blue-500',
            text: 'text-blue-500',
            bg: 'bg-blue-50',
            border: 'border-blue-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['service_client'],
    },
    to_ship: {
        label: 'Renvoi au client',
        classes: {
            dot: 'bg-orange-500',
            text: 'text-orange-500',
            bg: 'bg-orange-50',
            border: 'border-orange-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: ['logistique'],
    },
    restocking: {
        label: 'Remise en stock',
        classes: {
            dot: 'bg-orange-500',
            text: 'text-orange-500',
            bg: 'bg-orange-50',
            border: 'border-orange-200',
        },
        validTypes: ['return', 'swap_same'],
        teams: ['logistique'],
    },
    finished: {
        label: 'Terminé',
        classes: {
            dot: 'bg-gray-400',
            text: 'text-gray-400',
            bg: 'bg-gray-50',
            border: 'border-gray-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: [],
    },
    refused: {
        label: 'Refusé',
        classes: {
            dot: 'bg-red-500',
            text: 'text-red-500',
            bg: 'bg-red-50',
            border: 'border-red-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: [],
    },
    cancelled: {
        label: 'Annulé',
        classes: {
            dot: 'bg-gray-400',
            text: 'text-gray-400',
            bg: 'bg-gray-50',
            border: 'border-gray-200',
        },
        validTypes: ['repair', 'return', 'swap_same'],
        teams: [],
    },

    // Colonnes virtuelles (pas des statuts réels, utilisées dans le kanban)
    pending_swap: {
        label: 'BP à créer',
        classes: {
            dot: 'bg-blue-500',
            text: 'text-blue-500',
            bg: 'bg-blue-50',
            border: 'border-blue-200',
        },
        virtual: true,
        teams: ['service_client'],
    },
    pending_refund: {
        label: 'Remboursements à effectuer',
        classes: {
            dot: 'bg-blue-500',
            text: 'text-blue-500',
            bg: 'bg-blue-50',
            border: 'border-blue-200',
        },
        virtual: true,
        teams: ['service_client'],
    },
}

const defaultClasses = {
    dot: 'bg-gray-400',
    text: 'text-gray-400',
    bg: 'bg-gray-50',
    border: 'border-gray-200',
}

// Types de service cases
export const serviceCaseTypes = {
    repair: { label: 'Réparation', icon: Tool01 },
    return: { label: 'Remboursement', icon: ReverseLeft },
    swap_same: { label: 'Échange', icon: SwitchHorizontal01 },
}

// Lieux de traitement
export const handlingLocations = {
    none: { label: 'Non affecté' },
    baltic_workshop: { label: 'Atelier Baltic' },
    central_watch: { label: 'Central Watch' },
}

// Objets présents à la réception
export const receptionItems = {
    baltic_case: { label: 'Écrin Baltic' },
    customer_case: { label: 'Étui client' },
    strap: { label: 'Bracelet' },
    warranty_card: { label: 'Carte de garantie' },
}

// Helpers
export const getServiceCaseStatus = (status) => {
    return (
        serviceCaseStatuses[status] || {
            label: status,
            classes: defaultClasses,
        }
    )
}

export const getServiceCaseType = (type) => {
    return serviceCaseTypes[type] || { label: type }
}

// Tous les lieux (incluant les legacy comme MNP) pour affichage et filtres
const allHandlingLocations = {
    ...handlingLocations,
    mnp: { label: 'MNP' },
}

export const getHandlingLocation = (location) => {
    return allHandlingLocations[location] || { label: location }
}

// Options pour les filtres
export const statusFilterOptions = Object.entries(serviceCaseStatuses)
    .filter(([, config]) => !config.virtual)
    .map(([value, { label }]) => ({ value, label }))

export const typeFilterOptions = Object.entries(serviceCaseTypes).map(
    ([value, { label }]) => ({ value, label })
)

export const handlingLocationFilterOptions = Object.entries(
    allHandlingLocations
).map(([value, { label }]) => ({ value, label }))
